import CategoryIcon from "@mui/icons-material/Category"
// import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined'
import StorefrontIcon from "@mui/icons-material/Storefront"
// import LocalShippingIcon from '@mui/icons-material/LocalShipping'

const ServiceMenu = {
    id: 'servicesRoot',
    title: 'SERVICES/PRODUCTS',
    type: 'group',
    children: [
        {
            id: 'categories',
            title: 'Category',
            type: 'item',
            url: '/categories',
            icon: CategoryIcon
        },
        // {
        //     id: 'subCategories',
        //     title: 'Skincare Category',
        //     type: 'item',
        //     url: '/subCategories',
        //     icon: CategoryOutlinedIcon
        // },
        {
            id: 'products',
            title: 'Products',
            type: 'item',
            url: '/products',
            icon: StorefrontIcon
        }
        // {
        //     id: 'suppliers',
        //     title: 'Suppliers',
        //     type: 'item',
        //     url:'/suppliers',
        //     icon: LocalShippingIcon
        // }
    ]
}
export default ServiceMenu